import { render } from "./purchase-profile.vue?vue&type=template&id=4a5d8de8"
import script from "./purchase-profile.vue?vue&type=script&lang=js"
export * from "./purchase-profile.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__